import React, { Component } from 'react'

import { NavLink,Link } from "react-router-dom";

export default class SidebarList extends Component {
    render() {
        return (
            <>
            <li className="nav-item active" data-nav="1">
          {/* <a className="nav-link" href="#">Getting Start</a> */}
              <Link className="nav-link" to="/getting-start" href="#">Getting Start</Link>
          </li>
          <li className="nav-item" data-nav="2">
              <NavLink  className="nav-link" activeClassName="hurray" to="/example">Example</NavLink>
          </li>
          {/* <li className="nav-item" data-nav="3">
              <Link className="nav-link" to="/api" href="#">API</Link>
          </li>
          <li className="nav-item" data-nav="4">
              <Link className="nav-link" to="/themes" href="#">Themes</Link>
          </li>
          <li className="nav-item" data-nav="5">
              <Link className="nav-link" to="/options" href="#">Options</Link>
          </li> */}
    </>
        )
    }
}
